/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { MerkleProof, MerkleProofInterface } from "../MerkleProof";

const _abi = [
  {
    inputs: [],
    name: "MerkleProofInvalidMultiproof",
    type: "error",
  },
] as const;

export class MerkleProof__factory {
  static readonly abi = _abi;
  static createInterface(): MerkleProofInterface {
    return new Interface(_abi) as MerkleProofInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): MerkleProof {
    return new Contract(address, _abi, runner) as unknown as MerkleProof;
  }
}
